/* Cart page additions. Mode continues to own quantities, totals and section refresh. */
(() => {
  let busy = false;
  async function apply(control) {
    const input = control.querySelector('[data-discount-input]');
    const button = control.querySelector('[data-discount-apply]');
    const status = control.querySelector('[data-discount-status]');
    const code = input.value.trim();
    const form = control.closest('cart-form');
    if (!code || busy || form?.classList.contains('cart-form--refreshing')) return;
    busy = true; button.disabled = true; input.readOnly = true;
    status.textContent = control.dataset.loading;
    const root = window.Shopify?.routes?.root || '/';
    let mutated = false;
    try {
      const before = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!before.ok) throw new Error('Cart unavailable');
      const cart = await before.json();
      const existing = (cart.discount_codes || []).filter(x => x.applicable).map(x => x.code);
      const discounts = [...new Set([...existing, code])];
      mutated = true;
      const response = await fetch(`${root}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:discounts.join(',')})});
      if (!response.ok) throw new Error('Discount unavailable');
      const result = await response.json();
      const applied = (result.discount_codes || []).some(x => x.applicable && x.code.toLowerCase() === code.toLowerCase());
      status.textContent = applied ? '' : control.dataset.invalid;
      if (applied) {
        control.dataset.activeCodes = code;
        button.textContent = control.dataset.activated;
        button.classList.add('is-active');
      }
    } catch (_) {
      status.textContent = control.dataset.error;
    } finally {
      if (mutated) document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged',{bubbles:true,detail:{openDrawer:false}}));
      busy = false; button.disabled = button.classList.contains('is-active'); input.readOnly = false;
    }
  }
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-discount-input]')) return;
    const control = event.target.closest('[data-cart-discount-control]');
    const button = control.querySelector('[data-discount-apply]');
    const active = event.target.value.trim().toLowerCase() === control.dataset.activeCodes.toLowerCase() && Boolean(control.dataset.activeCodes);
    button.classList.toggle('is-active', active);
    button.textContent = active ? control.dataset.activated : control.dataset.applyLabel;
    button.disabled = active;
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-discount-apply]');
    if (button) {event.preventDefault();apply(button.closest('[data-cart-discount-control]'));}
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-discount-input]')) {event.preventDefault();apply(event.target.closest('[data-cart-discount-control]'));}
  });
})();
